import * as React from "react";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { GroupType } from "../../graphql/types";
import { Input, Select, Textarea } from "../wombat-ui";
import useTranslations from "../../hooks/useTranslations";

interface InsertGroupFormProps {
  group: {
    id?: string;
    name: string;
    description?: string;
    type?: string;
    companyId?: string;
  };
  submit;
}

export const InsertGroupForm: React.FC<InsertGroupFormProps> = ({
  group,
  submit,
}) => {
  const t = useTranslations();
  const { handleSubmit, register, setValue, unregister } = useForm({
    defaultValues: {
      ...group,
    },
  });

  const groupsTypes = useMemo(
    (): {
      value: GroupType;
      label: string;
    }[] => [
      {
        value: "Group::Other",
        label: t("groups.types.Group::Other") as string,
      },
      {
        value: "Group::Team",
        label: t("groups.types.Group::Team") as string,
      },
      {
        value: "Group::Partner",
        label: t("groups.types.Group::Partner") as string,
      },
      {
        value: "Group::Subsidiary",
        label: t("groups.types.Group::Subsidiary") as string,
      },
      {
        value: "Group::TrainingCourse",
        label: t("groups.types.Group::TrainingCourse") as string,
      },
    ],
    []
  );

  return (
    <form
      onSubmit={handleSubmit(submit)}
      id="insertGroupForm"
      className="flex flex-col gap-y-4"
    >
      <input type="hidden" name="id" ref={register()} />
      <div className="flex gap-x-6">
        <div className="flex-grow max-w-sm">
          <Input
            id="name"
            className="w-full"
            label={t("groups.name") as string}
            name="name"
            ref={register()}
          />
        </div>
        <Select
          id="group-type"
          label={t("groups.type") as string}
          items={groupsTypes}
          defaultValue={groupsTypes[0]}
          searchOption={{
            keys: ["label"],
            threshold: 0.2,
            useExtendedSearch: true,
          }}
          getValue={(i) => i.value}
          renderItem={(i) => i.label}
          searchable
          RHF={{ register, name: "type", setValue, unregister }}
        />
      </div>
      <div className="max-w-2xl">
        <Textarea
          id="description"
          rows={3}
          label={t("groups.description") as string}
          name="description"
          ref={register()}
        />
      </div>
    </form>
  );
};
